import { render, staticRenderFns } from "./SelectedFilter.vue?vue&type=template&id=2e4cd446&scoped=true&"
import script from "./SelectedFilter.vue?vue&type=script&lang=ts&"
export * from "./SelectedFilter.vue?vue&type=script&lang=ts&"
import style0 from "./SelectedFilter.vue?vue&type=style&index=0&id=2e4cd446&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4cd446",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VContainer,VIcon})
